import React, { useEffect, useState } from 'react';
import axios from 'axios';
import URL from '../constants/ServerUrl';
import { useSearchParams } from 'react-router-dom';

const Dues = ({ route }) => {
  const [data, setData] = useState([]);
  const [totalBalance, setTotalBalance] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem('dairy-token');

  useEffect(() => {
    const fetchAllFarmers = async () => {
      try {
        if (username) {
          setIsLoading(true);
          const dues = await axios.get(`${URL}admin/${username}/dues`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          const duesArray = dues.data.map((due) => ({
            farmerName: due.farmerName,
            farmerId: due.farmerId,
            netBalance: due.dues,
          }));

          setData(duesArray);
          const total = duesArray.reduce((acc, item) => acc + parseFloat(item.netBalance), 0);
          setTotalBalance(total.toFixed(2));
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };

    fetchAllFarmers();
  }, [username]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = data.filter((item) => {
    const farmerIdString = String(item.farmerId); // Convert farmerId to string
    return (
      farmerIdString.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.farmerName.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  const tableHead = [
    { label: 'Farmer Id', flex: 'flex-2' },
    { label: 'Farmer Name', flex: 'flex-5' },
    { label: 'Net Balance', flex: 'flex-3' },
  ];

  const tableData = filteredData.map((item) => [item.farmerId, item.farmerName, item.netBalance]);

  return (
    <div className="p-4">
      <div className="flex mb-4">
        {/* Search input field */}
        <input
          type="text"
          placeholder="Search by Farmer ID or Name"
          value={searchQuery}
          onChange={handleSearch}
          className="px-4 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
        />
      </div>
      {isLoading ? (
        <div className="text-center">
          <div className="text-lg font-bold">Loading Farmer Dues...</div>
        </div>
      ) : tableData.length === 0 ? (
        <div className="text-center">
          <div className="text-lg font-bold">No Farmers Found</div>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="table-auto w-full">
            <thead>
              <tr>
                {tableHead.map((header, index) => (
                  <th key={index} className={`border px-4 py-2 font-semibold ${header.flex}`}>
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((rowData, index) => (
                <tr key={index} className="border-b">
                  {rowData.map((dataItem, dataIndex) => (
                    <td key={dataIndex} className={`border px-4 py-2 ${tableHead[dataIndex].flex}`}>
                      {dataItem}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="text-right mt-4">
        <div className="font-bold">TOTAL AMOUNT: {totalBalance}</div>
      </div>
    </div>
  );
};

export default Dues;
